import { render, staticRenderFns } from "./ProjectAnalyticsInbox.vue?vue&type=template&id=476b06a2"
import script from "./ProjectAnalyticsInbox.vue?vue&type=script&lang=ts"
export * from "./ProjectAnalyticsInbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports